import { apiGet } from "components/Common/Axios";
import toast from "react-hot-toast";
import { SchoolSales } from "lib/models";
import { useEffect, useState } from "react";
import SchoolSalesListView from "./SchoolSalesListView";

function SchoolSalesTotalView() {
  const [schoolSalesList, setSchoolSalesList] = useState<SchoolSales[]>([]);

  const loadSales = async () => {
    const response = await apiGet("/school/sales-total");

    if (response.error) {
      toast.error("학교 정보를 불러오는데 실패했습니다.");
      console.error("loadSales error", response.error);
      return;
    }

    setSchoolSalesList(response.data);
  };

  useEffect(() => {
    loadSales();
  }, []);

  return (
    <SchoolSalesListView
      schoolSalesList={schoolSalesList}
      setSchoolSalesList={setSchoolSalesList}
      isTotal={true}
    />
  );
}

export default SchoolSalesTotalView;
